import { Box, Divider } from '@wix/design-system';
import { FC, useMemo } from 'react';
import { FavoriteFilledSmall } from '@wix/wix-ui-icons-common';
import ReviewScore from '../ReviewScore';
import CompletedProjectCount from '../CompletedProjectCount';
import s from '../ProviderReviewSummary.module.scss';

const dataHooks = {
  container: 'review-summary-content-container',
  reviewScore: 'review-summary-content-review-socre',
  projectCount: 'review-summary-content-project-count',
};
interface ReviewSummaryContentProps {
  isMobileView: boolean;
  isStickyMobileView: boolean;
  averageRating: number;
  reviewsCount: number;
  completedProjects: number;
  hasReviews: boolean;
}

const ReviewSummaryContent: FC<ReviewSummaryContentProps> = ({
  isMobileView,
  isStickyMobileView,
  averageRating,
  reviewsCount,
  completedProjects,
  hasReviews,
}) => {
  const splitIntoTwoLines = useMemo(
    () => !isMobileView && (completedProjects > 999 || reviewsCount > 99),
    [isMobileView, completedProjects, reviewsCount],
  ); // incase projects is 4 digits or reviews is 3 digits, we need to split into two lines
  return (
    <Box
      direction={splitIntoTwoLines ? 'vertical' : 'horizontal'}
      dataHook={dataHooks.container}
    >
      <Box
        direction="horizontal"
        verticalAlign="middle"
        dataHook={dataHooks.reviewScore}
      >
        <FavoriteFilledSmall
          className={s.ratingStarIcon}
          color={hasReviews ? '#000624' : '#CFD1DC'}
        />
        <ReviewScore
          isMobileView={isMobileView}
          isStickyMobileView={isStickyMobileView}
          averageReviewRating={averageRating}
          reviewsCount={reviewsCount}
        />
      </Box>

      {!isStickyMobileView && (
        <Box
          verticalAlign="middle"
          paddingLeft={splitIntoTwoLines ? '3px' : '0px'}
          dataHook={dataHooks.projectCount}
        >
          {!splitIntoTwoLines && (
            <Box height="24px" margin="0 6px">
              <Divider direction="vertical" />
            </Box>
          )}
          <CompletedProjectCount
            isMobileView={isMobileView}
            completedProjectsCount={completedProjects}
          />
        </Box>
      )}
    </Box>
  );
};

export default ReviewSummaryContent;
